import { motion } from "framer-motion";
import { easeOut } from "./anim";

export function MaskLineOnView({ children, delay = 0, className = "" }) {
  return (
    <motion.span
      className={`block overflow-hidden ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-8% 0px -8% 0px" }}
    >
      <motion.span
        className="block"
        variants={{ hidden: { y: "110%" }, visible: { y: "0%" } }}
        transition={{ duration: 1, ease: easeOut, delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}
